<template>
  <page :setup="setup">
    <el-tabs class="eco-tabs" v-model="tab">
      <el-tab-pane label="经评参数" name="form">
        <form-economic
          :formData="formData"
          :windfarmData="windfarmData"
          @reset="reset"
          @save="save"
        />
      </el-tab-pane>
      <el-tab-pane label="经评结果" name="result">
        <el-tabs v-model="resultTab">
          <el-tab-pane label="关键财务指数汇总表" name="result">
            <compare-table :eco="eco"></compare-table>
          </el-tab-pane>
          <el-tab-pane label="敏感性分析结果" name="sensitivity">
            <sensitivity :eco="eco"></sensitivity>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </page>
</template>

<script>
import { prefix, postfix } from '@/components/form-economic/arr-key';
import CompareTable from './components/compare-table';
import Sensitivity from './components/sensitivity';

export default {
  components: {
    Sensitivity,
    CompareTable
  },
  props: {},
  data() {
    return {
      formData: null,
      defaultParam: {},
      tab: 'form',
      resultTab: 'result',
      eco: null,
      windfarmData: null
    };
  },
  computed: {},
  methods: {
    async setup() {
      const [defaultParamRes, eco] = await Promise.all([
        this.getDefaultParam(),
        this.getEco()
      ]);
      let param;
      if (eco?.economicPlan) {
        const { economicPlan, ...windfarmData } = eco;
        this.eco = economicPlan;
        this.windfarmData = windfarmData;
        param = prefix(economicPlan);
      } else {
        const { defaultParam, ...windfarmData } = defaultParamRes;
        this.windfarmData = windfarmData;
        param = prefix(defaultParam);
      }
      this.defaultParam = param;
      this.reset();
    },
    async getDefaultParam() {
      const res = await this.$fetch({
        url: '/windfarm/economic/getDefaultParam',
        params: {
          windfarmId: this.$route.query.windfarmId
        }
      });
      return res.data;
    },
    async getEco(showLoading) {
      const res = await this.$fetch({
        url: '/windfarm/economic/getEconomicPlan',
        params: {
          windfarmId: this.$route.query.windfarmId
        },
        showLoading
      });
      return res.data;
    },
    async save() {
      try {
        const data = {
          ...this.formData,
          whetherLcoe: 1,
          windfarmId: this.$route.query.windfarmId
        };

        postfix(data);

        if (typeof data.constructionStarttime !== 'string') {
          data.constructionStarttime = this.$moment(
            data.constructionStarttime
          ).format('YYYY-MM');
        }
        if (!data.whetherSense) {
          data.energyDataArr = null;
          data.totalInvestArr = null;
          data.priceWithArr = null;
          data.loanInterestRateArr = null;
        }
        console.log('before submit', data);
        const res = await this.$fetch({
          url: '/windfarm/economic/saveEconomicPlan',
          data,
          method: 'post',
          showError: true,
          showLoading: true,
          showSuccess: true
        });
        console.log('res', res);
        this.switchToResult();
      } catch (e) {
        console.log('submit err', e);
      }
    },
    reset() {
      this.formData = { ...this.defaultParam };
      //console.log('reset current form', this.formData);
    },
    tabClick(tab) {
      if (tab && tab.name === 'result') {
        if (!this.eco) {
          this.switchToResult();
        }
      }
    },
    async switchToResult() {
      const result = await this.getEco(true);
      this.eco = result?.economicPlan;
      this.tab = 'result';
    }
  }
};
</script>

<style lang="less" scoped>
.eco-tabs {
  background: #fff;

  /deep/.el-tabs__header {
    margin-left: 20px;
  }
}
</style>
